export default "__VITE_ASSET__C1lUM7GT__"